import { Component } from '@angular/core';
@Component({
  selector: 'megastore-main-layout',
  templateUrl: './main-layout.component.html',
  styleUrls: ['./main-layout.component.scss']
})
export class MainLayoutComponent {}
